'use client';

import { useCustomProperties, useNavigationFooter, useNavigation } from '@networkteam/giraffe';

import Footer from '../../ui/Footer';
import Header from '../../ui/Header';
import { themeContext } from '@/lib/utils/themeContext';
import { ThemeColor } from '@/lib/config/colors';
import CookieProvider from '@/lib/cookieconsent/CookieConsent';
import CookieManager from '@/lib/cookieconsent/CookieManager';
import BodyScripts from './BodyScripts';
import Styles from './Styles';
import { LoaderProvider } from '@/lib/utils/imageloader/LoaderContext';
import { ContentWidthsProvider } from '@/lib/utils/contentSizeContext';
import PreviewIndicator from '@/lib/components/ui/PreviewIndicator';

type LayoutProps = {
  children: React.ReactNode;
};

const logos = [
  {
    src: '/assets/logos/diakonie-hamburg-logo.svg',
    alt: 'Diakonie Hamburg',
    url: 'https://www.diakonie-hamburg.de',
  },
  {
    src: '/assets/logos/vek-sh-logo.svg',
    alt: 'Verband Evangelischer Kindertageseinrichtungen in Schleswig-Holstein e.V.',
    url: 'https://www.vek-sh.de',
  },
  {
    src: '/assets/logos/kirche-hh-logo.svg',
    alt: 'Evangelisch-Lutherische Kirche in Hamburg und Umgebung',
    url: 'https://www.kirche-hamburg.de',
  },
];

const Layout = ({ children }: LayoutProps) => {
  const customProperties = useCustomProperties();
  const navigationFooter = useNavigationFooter();
  const navigation = useNavigation();

  return (
    <LoaderProvider>
      <ContentWidthsProvider>
        <themeContext.Provider
          value={{ color: (customProperties?.color as ThemeColor) || 'purple', backgroundColor: 'white' }}
        >
          <CookieProvider locale="de">
            <BodyScripts />
            <Styles />

            <div className="flex min-h-screen flex-col">
              <Header navigationItems={navigation || []} />
              <main className="flex grow flex-col justify-between overflow-x-hidden">
                {children}
                <Footer
                  description={
                    <div className="c-bodytext">
                      <a href="https://www.eva-kita.de">www.eva-kita.de</a> ist der gemeinsame Auftritt evangelischer
                      Kindertagesstätten in der Metropolregion Hamburg.
                    </div>
                  }
                  logos={logos}
                  navItems={navigationFooter?.map((item) => ({
                    label: item.title,
                    url: item.link,
                  }))}
                />
              </main>
            </div>
            <CookieManager />
            <PreviewIndicator />
          </CookieProvider>
        </themeContext.Provider>
      </ContentWidthsProvider>
    </LoaderProvider>
  );
};

export default Layout;
